import { FC, useMemo } from 'react';

import { SelectField } from '@app/components/common';
import { FieldComponentProps } from '@app/components/common/types';

const paymentDefermentOptions = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 14, 21, 30,
].map((value) => ({ id: value, name: '' + value }));

export const PaymentDefermentField: FC<FieldComponentProps<number>> = ({ value, onChange, ...props }) => { 

  const selectedItem = useMemo(() => {
    if (!value) {return undefined;}
    return paymentDefermentOptions.find(({ id }) => id === value);
  }, [value]);
  return <SelectField 
    id='deferment_field'  
    value={selectedItem}
    onChangeValue={(val) => onChange(Number(val))}
    options={paymentDefermentOptions}
    {...props}
  />;
}; 